import { __decorate } from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
let PiDetailsItem = class PiDetailsItem extends Vue {
    constructor() {
        super(...arguments);
        this.scroll = {};
    }
    get getNameWidth() {
        if (this.nameWidth == "") {
            return {};
        }
        else if (typeof this.nameWidth == "string") {
            return { width: this.nameWidth };
        }
        else {
            return { width: this.nameWidth + "px" };
        }
    }
};
__decorate([
    Prop({ default: "" })
], PiDetailsItem.prototype, "name", void 0);
__decorate([
    Prop({ default: false })
], PiDetailsItem.prototype, "flex", void 0);
__decorate([
    Prop({ default: "" })
], PiDetailsItem.prototype, "nameWidth", void 0);
PiDetailsItem = __decorate([
    Component({
        components: {},
    })
], PiDetailsItem);
export default PiDetailsItem;
